import Vue from "vue";

import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";

import env from "./env";

// Allow SeverityLevel to be imported in other modules from this file
export { SeverityLevel } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: env.appInsightsInstrumentationKey,
    enableAutoRouteTracking: true, // This adds support for single page applications
    autoTrackPageVisitTime: true
  }
});

type Primitive = string | number | boolean | undefined | null;
type Source = string | Vue;

function getSourceName(source?: Source) {
  if (!source) return "unknown";
  if (typeof source === "string") return source;

  return source?.$vnode?.tag;
}

export function logError(source: Source, error: any, severity?: SeverityLevel, properties?: Record<string, Primitive>) {
  // Copy the properties to a new object so that it new properties can be added without affecting the caller
  const props = Object.assign({}, properties ?? {});

  // Add the source name (if it's a Vue component, use the component's name)
  props.source = getSourceName(source);

  // Note, App Insights requires exception to be an Error. If it isn't an error, wrap it in one
  const err = error instanceof Error ? error : new Error(error);

  const details = {
    severityLevel: severity ?? SeverityLevel.Error,
    exception: err,
    properties: props
  };

  // appInsights.trackException(details);
  console.error(details);
}

export default appInsights;
